import { css, SerializedStyles } from '@emotion/react'
import CloseIcon from '@mui/icons-material/Close'
import { memo } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import IconButton from './IconButton'

const zeroedOutStyles = css({
    top: 9,
    right: 7,
    background: 'transparent',
    borderRadius: 0,
    padding: 5,
})
const closeStyles = css({
    borderRadius: '100%',
    '&:hover': {
        backgroundColor: palette.background,
    },
    padding: getThemeSpacing(1),
    position: 'absolute',
    background: palette.background,
    boxShadow: '0px 0px 3px 1px ' + palette.dialogButtonShadows,
    border: 'none',
    minWidth: 'auto',
    right: -32,
    top: -36,
    zIndex: 89,
    '& .MuiIconSvg-root': {
        fontSize: 22,
    },
})
const embedStyles = css({
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 2,
    padding: 6,
})
const embedWithBackgroundStyles = css({
    position: 'absolute',
    zIndex: 2,
    right: -20,
    top: -20,
    background: palette.background,
    '&:hover': {
        background: palette.background,
    },
})
const buttonStyles = css({
    borderRadius: '100%',
    minWidth: 'auto',
    padding: 12,
    '&:hover': {
        backgroundColor: palette.background,
    },
})

const opacityStyles = css({
    opacity: 0.55,
})

interface IButtonDialogClose {
    title?: boolean
    onClick?(event?: any, reason?: string): void
    embedClose?: boolean
    noBackground?: boolean
    zeroedOut?: boolean
}

const ButtonDialogClose = memo((props: IButtonDialogClose) => {
    const {
        onClick,
        embedClose,
        noBackground,
        title,
        zeroedOut = false,
    } = props
    const classes: Array<SerializedStyles> = []
    if (embedClose && noBackground) classes.push(embedStyles)
    if (embedClose && !noBackground) classes.push(embedWithBackgroundStyles)
    if (!embedClose && title) classes.push(buttonStyles)
    if (!embedClose && !title) classes.push(closeStyles)
    if (zeroedOut) classes.push(zeroedOutStyles)

    return (
        <IconButton
            css={classes}
            onClick={onClick}
            data-testid="IconButton__CloseIcon"
        >
            <CloseIcon css={!title ? opacityStyles : null} />
        </IconButton>
    )
})

export default ButtonDialogClose
